import { usePreferences } from 'context/preferences/PreferencesContext'
import { ContactCompanyType } from 'models/contact_companies'
import React from 'react'
import { useParams } from 'react-router-dom'
import apiService from 'services/api'
import { getIdWithPrefix } from 'utils/pathUtils'
import CommonPage from 'components/DataExpansionComponents/Common/CommonPage'
import { featureFlagService } from 'utils/featureFlagService'
import LoadingScreen from 'components/Layout/LoadingScreen'

import { NewK12DistrictPage } from './new-company-pages/NewK12DistrictPage'

export default function K12DistrictPage() {
  const urlParams = useParams()
  const { preferences } = usePreferences()
  const { enableNewCompanyPage, isLoading: isFeatureFlagLoading } =
    featureFlagService()
  const k12ChainId = urlParams?.id
    ? getIdWithPrefix(
        urlParams?.id,
        preferences?.company_type_prefix_map[ContactCompanyType.K12District]
      )
    : undefined

  if (isFeatureFlagLoading) {
    return <LoadingScreen />
  }

  if (enableNewCompanyPage) {
    return <NewK12DistrictPage k12DistrictID={k12ChainId} />
  } else {
    return <K12DistrictPageComponent k12ChainId={k12ChainId} />
  }
}

export function K12DistrictPageComponent({
  k12ChainId,
}: {
  k12ChainId?: number
}) {
  const api = apiService()
  const { data, isLoading, isError, error } = api.useGetK12District(k12ChainId)

  return (
    <CommonPage
      uniqueCompanyTypeId={k12ChainId}
      useGetCompany={{
        companyData: data,
        contactCompanyData: data,
        isLoading,
        isError,
        error,
      }}
      tableTypeSlug="education-k-12"
      companyTypeSlug="education-k-12"
      breadcrumbs={[
        {
          title: 'K12 District',
          breadcrumb: data?.k12district?.lea_name,
        },
      ]}
      getFieldsFromData={(data) => ({
        contactCompanyId: data?.id,
        companyName: data?.k12district?.lea_name,
        websiteAddress: data?.k12district?.website,
        address: {
          addressUrl: data?.k12district?.google_place_url,
          addressInfo: {
            fullAddress: data?.k12district?.address,
            city: data?.k12district?.lcity,
            state: data?.k12district?.lstate,
            zipcode: data?.k12district?.zipcode,
          },
          fullAddressInfo: data?.k12district?.address_info,
        },
      })}
      doorSectionConfig={
        data
          ? {
              type: 'unmatched-only',
              forChainProxyId: data.id,
              chainData: {
                id: data.id,
                name: data.k12district?.lea_name,
                domain: data.k12district?.website,
              },
              subCategory: {
                name: 'K-12 Education',
                slug: 'education-k-12',
                description: 'K-12 Education',
              },
              unmatchedTableKeyPrefix: 'unmatched-k12-doors-table',
            }
          : undefined
      }
    />
  )
}
